// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const ResultsConfig = () => (function(config: any) {
   const results : any = {}
   if (config.maverick != null) { results.librarianContactUrl = config.maverick.librarian_contact_url.trim() }
   if (config.toolbar?.refine_search_selection != null) { 
      results.addResultsBeyondCatalog = config.toolbar.refine_search_selection.includes('add_results_beyond_catalog') 
      results.includeMatchesFulltextOverride = config.toolbar.refine_search_selection.includes('include_matches_full_text_override')
   }
   if (config.advanced_search != null) { results.enableJournalTitleLink = config.advanced_search.enable_journal_title_link }
   if (config.site != null) {
      results.enableTransliterations = config.site.enable_transliterations
      results.showRss = config.site.enable_rss_icon
      results.showDBRecommenderResults = config.site.db_recommender_enabled
      results.enableQuerySuggestions = config.site.enable_query_suggestions
      results.pageSize = config.site.default_search_result_count
      results.showRtaForDbid = config.site.rta_enabled_for_dbid
      // set pagesToShow to 5 pages if page size is 10 and 2 pages if it's 25 totaling 50 displayed results in either case
      results.pagesToShow = results.pageSize === 10 ? 5 : 2
   }
   if (config.search_results != null) {
      results.displayCitationCounts = config.search_results.display_citation_counts_enabled
      results.displayResultCounts = config.search_results.display_result_counts_enabled
      results.displayPermalink = config.search_results.display_permalink_enabled
      results.enableShortenPermalink = config.search_results.enable_shorten_permalink
      results.displayOpenAccessIndicator = config.search_results.open_access
      results.addOpenAccessLink = config.search_results.show_open_access_link
      results.displayPeerReviewIndicator = config.search_results.peer_review
      results.displayOnlineIndicator = config.search_results.show_online_access_indicator
      results.displayCitationTrail = config.search_results.display_citation_trail
      results.displayRelatedItems = config.search_results.enable_related_items
      results.displayPdfQuickLinks = config.search_results.display_pdf_quicklinks
      results.displayHtmlQuickLinks = config.search_results.display_html_quicklinks
      results.enableAdditionalFullTextLinks = config.search_results.enable_additional_full_text_links
      results.maximumFullTextLinks = config.search_results.maximum_full_text_links
      results.displayEditor = config.search_results.display_editor
      results.proxyDoiLinks = config.search_results.proxy_doi_links
      results.displayLinkResolver = config.search_results.display_link_resolver
      results.displayJournalCoverageRanges = config.search_results.display_journal_coverage_ranges
      results.isAlmaClient = !!config.info.almaId
      results.almaId = config.info.almaId
      results.displayDocInsights = config.search_results.display_a_i_insights
   }
   return results
})

angular.module('summonApp.factories.configs')
   .factory('resultsConfig', ResultsConfig)
